import { createFileRoute } from '@tanstack/react-router'
import { AddUserForm, UserQueries } from '@portal/app-admin'

export const Route = createFileRoute('/_auth/preferences/users/new')({
  loaderDeps: ({ search: { orgId } }) => ({ orgId }),
  loader: ({ context: { queryClient }, deps: { orgId } }) =>
    queryClient.ensureQueryData(UserQueries.orgSettings(orgId)),
  component: NewUserRoute,
})

function NewUserRoute() {
  const navigate = Route.useNavigate()
  const { orgId } = Route.useSearch()

  return <AddUserForm orgId={orgId} onClose={() => void navigate({ to: '/preferences/users' })} />
}
